// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   MessageCircle,
//   X,
//   Send,
//   Phone,
//   Plus,
//   History,
//   ArrowLeft,
//   Star,
//   Loader2,
// } from "lucide-react";
// import { motion, AnimatePresence } from "framer-motion";
// import { API_URL } from "../../Constants"; // path adjust karo
// import { usePageContext } from "./integration/PageContext";
// import { parseApiInput, isExplicitApiPaste } from "./integration/apiSpecParser";
// import { buildDraft, buildPageSnapshot, maskSecrets, sanitizeValues, validateValues } from "./integration/mapper";
// import IntegrationCard from "./integration/IntegrationCard";

// /* ------------------------------------------------------------------ */
// /*  CONFIG – apne project ke hisaab se sirf yeh 2 cheezein badlo        */
// /* ------------------------------------------------------------------ */
// const API_BASE = API_URL;
// // Login ke baad jis key me JWT save karte ho
// const getToken = () =>
//   localStorage.getItem("token") || sessionStorage.getItem("token");

// /* ------------------------------------------------------------------ */
// /*  API helper                                                          */
// /* ------------------------------------------------------------------ */
// const apiFetch = async (path, options = {}) => {
//   const res = await fetch(`${API_BASE}/api/support${path}`, {
//     ...options,
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${getToken()}`,
//       ...(options.headers || {}),
//     },
//   });

//   let data = null;
//   const text = await res.text();
//   if (text) {
//     try {
//       data = JSON.parse(text);
//     } catch {
//       data = { message: text };
//     }
//   }

//   if (!res.ok) {
//     const err = new Error(
//       data?.message ||
//         (res.status === 404
//           ? "Conversation not found."
//           : "Something went wrong. Please try again.")
//     );
//     err.status = res.status;
//     throw err;
//   }
//   return data;
// };

// const telHref = (phone) => `tel:${(phone || "").replace(/[^\d+]/g, "")}`;

// /* ------------------------------------------------------------------ */
// /*  Small UI pieces                                                     */
// /* ------------------------------------------------------------------ */
// const TypingIndicator = () => (
//   <div className="flex gap-1 bg-white dark:bg-gray-700 border border-gray-100 dark:border-gray-600 w-fit px-3 py-3 rounded-lg rounded-tl-none shadow-sm">
//     {[0, 1, 2].map((i) => (
//       <span
//         key={i}
//         className="w-2 h-2 rounded-full bg-[#673AB7]/60 dark:bg-gray-300 animate-bounce"
//         style={{ animationDelay: `${i * 0.15}s` }}
//       />
//     ))}
//   </div>
// );

// const Bubble = ({ msg }) => {
//   const isUser = msg.role === "user";
//   return (
//     <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
//       <div
//         className={`max-w-[85%] p-3 text-xs leading-relaxed shadow-sm rounded-lg ${
//           isUser
//             ? "bg-[#673AB7] text-white rounded-tr-none"
//             : msg.error
//             ? "bg-red-50 text-red-700 border border-red-200 rounded-tl-none"
//             : "bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100 border border-gray-100 dark:border-gray-600 rounded-tl-none"
//         }`}
//         // Plain text only – never inject as HTML
//         style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
//       >
//         {msg.text}
//       </div>
//     </div>
//   );
// };

// const CallCard = ({ phone, hours }) => {
//   if (!phone) return null;
//   return (
//     <div className="border border-[#E9D5FF] bg-[#F3E8FF] dark:bg-purple-900/30 dark:border-purple-800 rounded-lg p-3 text-xs">
//       <p className="font-semibold text-[#673AB7] dark:text-white mb-1">
//         Need a person? Call our support team
//       </p>
//       {hours && (
//         <p className="text-xs text-gray-600 dark:text-gray-300 mb-2">{hours}</p>
//       )}
//       <a
//         href={telHref(phone)}
//         className="inline-flex items-center gap-2 bg-[#673AB7] hover:bg-[#5E35A6] text-white px-3 py-1.5 rounded-md font-medium transition-colors"
//       >
//         <Phone size={16} /> Call {phone}
//       </a>
//     </div>
//   );
// };

// const RatingBox = ({ onSubmit, submitting }) => {
//   const [rating, setRating] = useState(0);
//   const [hover, setHover] = useState(0);
//   const [comment, setComment] = useState("");

//   return (
//     <div className="border border-gray-100 dark:border-gray-600 rounded-lg p-3 text-xs bg-white dark:bg-gray-700">
//       <p className="font-medium text-gray-800 dark:text-gray-100 mb-2">
//         How was this chat?
//       </p>
//       <div className="flex gap-1 mb-2">
//         {[1, 2, 3, 4, 5].map((n) => (
//           <button
//             key={n}
//             type="button"
//             onMouseEnter={() => setHover(n)}
//             onMouseLeave={() => setHover(0)}
//             onClick={() => setRating(n)}
//             aria-label={`${n} star`}
//           >
//             <Star
//               size={24}
//               className={
//                 n <= (hover || rating)
//                   ? "fill-[#8B5CF6] text-[#673AB7]"
//                   : "text-gray-300"
//               }
//             />
//           </button>
//         ))}
//       </div>
//       {rating > 0 && (
//         <>
//           <textarea
//             value={comment}
//             maxLength={500}
//             onChange={(e) => setComment(e.target.value)}
//             placeholder="Anything to add? (optional)"
//             rows={2}
//             className="w-full px-2.5 py-1.5 border rounded text-xs dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#8B5CF6]"
//           />
//           <button
//             onClick={() => onSubmit(rating, comment.trim())}
//             disabled={submitting}
//             className="mt-2 bg-[#673AB7] text-white px-3 py-1.5 rounded hover:bg-[#5E35A6] disabled:opacity-60 transition-colors"
//           >
//             {submitting ? "Sending..." : "Submit rating"}
//           </button>
//         </>
//       )}
//     </div>
//   );
// };

// /* ------------------------------------------------------------------ */
// /*  Main component                                                      */
// /* ------------------------------------------------------------------ */
// const Chatbot = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [view, setView] = useState("chat"); // "chat" | "history"

//   // widget settings
//   const [widget, setWidget] = useState(null);
//   const [widgetLoaded, setWidgetLoaded] = useState(false);

//   // chat state
//   const [conversationId, setConversationId] = useState(null);
//   const [messages, setMessages] = useState([]);
//   const [input, setInput] = useState("");
//   const [sending, setSending] = useState(false);
//   const [callSuggested, setCallSuggested] = useState(false);
//   const [contact, setContact] = useState({ phone: null, hours: null });
//   const [tooLong, setTooLong] = useState(false);
//   const [rated, setRated] = useState(false);
//   const [ratingBusy, setRatingBusy] = useState(false);

//   // history
//   const [history, setHistory] = useState([]);
//   const [historyLoading, setHistoryLoading] = useState(false);

//   const bottomRef = useRef(null);
//   const cooldownRef = useRef(null);
//   const [cooldown, setCooldown] = useState(false);

//   // page-aware API integration
//   const { page, pathname } = usePageContext();
//   const [drafts, setDrafts] = useState({});
//   const [draftBusy, setDraftBusy] = useState(null);
//   const [awaitingApi, setAwaitingApi] = useState(false);

//   const maxLen = widget?.maxMessageLength || 1000;
//   const phone = contact.phone || widget?.supportPhoneNumber || null;
//   const hours = contact.hours || widget?.supportHours || null;
//   const userMsgCount = messages.filter((m) => m.role === "user").length;

//   /* ---------- load widget settings once (user must be logged in) ---------- */
//   useEffect(() => {
//     if (!getToken()) {
//       setWidgetLoaded(true);
//       return;
//     }
//     let alive = true;
//     apiFetch("/widget")
//       .then((data) => {
//         if (!alive) return;
//         setWidget(data);
//         setContact({
//           phone: data.supportPhoneNumber,
//           hours: data.supportHours,
//         });
//       })
//       .catch(() => {
//         if (alive) setWidget(null);
//       })
//       .finally(() => alive && setWidgetLoaded(true));
//     return () => {
//       alive = false;
//       clearTimeout(cooldownRef.current);
//     };
//   }, []);

//   /* ---------- auto scroll ---------- */
//   useEffect(() => {
//     bottomRef.current?.scrollIntoView({ behavior: "smooth" });
//   }, [messages, sending, callSuggested, view, isOpen]);

//   /* ---------- helpers ---------- */
//   const addMessage = (msg) => setMessages((prev) => [...prev, msg]);

//   const startCooldown = (ms = 4000) => {
//     setCooldown(true);
//     clearTimeout(cooldownRef.current);
//     cooldownRef.current = setTimeout(() => setCooldown(false), ms);
//   };

//   const applyReply = (data) => {
//     setConversationId(data.conversationId);
//     addMessage({
//       role: "model",
//       text: data.reply,
//       source: data.callSuggested ? "system" : "ai",
//     });
//     if (data.callSuggested) setCallSuggested(true);
//     if (data.supportPhoneNumber || data.supportHours) {
//       setContact({
//         phone: data.supportPhoneNumber,
//         hours: data.supportHours,
//       });
//     }
//   };

//   const handleError = (err) => {
//     if (err.status === 409 && /long/i.test(err.message)) {
//       setTooLong(true);
//     }
//     if (err.status === 429) startCooldown();
//     addMessage({ role: "model", text: err.message, error: true });
//   };

//   /* ---------- page-aware API integration ---------- */
//   const pageSnapshot = () => (page ? buildPageSnapshot(page, pathname) : null);
//   const patchDraft = (id, fn) => setDrafts((d) => (d[id] ? { ...d, [id]: fn(d[id]) } : d));

//   const startIntegration = () => {
//     setAwaitingApi(true);
//     addMessage({
//       role: "model",
//       text: `Paste your provider's cURL command, a "POST https://…" request with headers/body, or its docs. I'll map it to the ${page.title} fields so you can review it before saving.`,
//     });
//   };

//   const handleIntegrationInput = async (text, spec) => {
//     let draft = spec ? buildDraft(page, spec) : null;
//     if (!draft) {
//       // Optional AI fallback for messy docs. Secrets are masked before leaving the browser.
//       const { masked, restore } = maskSecrets(text);
//       try {
//         const data = await apiFetch("/integration/map", {
//           method: "POST",
//           body: JSON.stringify({ pageContext: pageSnapshot(), input: masked }),
//         });
//         const values = sanitizeValues(page.fields, restore(data?.values || {}));
//         if (Object.keys(values).length)
//           draft = {
//             id: `d_${Date.now()}`,
//             pageId: page.id,
//             spec: { method: values.httpMethod || "", baseUrl: values.url || "" },
//             values,
//             applied: false,
//             saved: false,
//           };
//       } catch {
//         /* fall through */
//       }
//     }
//     if (!draft) {
//       addMessage({
//         role: "model",
//         error: true,
//         text: "I couldn't read an API request from that. Please paste a cURL command or a request like “POST https://…” with its headers and body.",
//       });
//       return;
//     }
//     setDrafts((d) => ({ ...d, [draft.id]: draft }));
//     addMessage({
//       role: "model",
//       kind: "integration",
//       draftId: draft.id,
//       text: "I've mapped your API to this page. Review the values, then fill the form.",
//     });
//   };

//   const editDraft = (id, key, value) =>
//     patchDraft(id, (d) => ({ ...d, values: { ...d.values, [key]: value }, applied: false }));
//   const applyDraft = (id) => {
//     page.setValues(drafts[id].values);
//     patchDraft(id, (d) => ({ ...d, applied: true }));
//   };
//   const discardDraft = (id) =>
//     setDrafts((d) => {
//       const n = { ...d };
//       delete n[id];
//       return n;
//     });

//   const saveDraft = async (id) => {
//     // validate what is actually on the page, not just the draft
//     const errs = validateValues(page.fields, page.getValues(), page.validate);
//     if (Object.keys(errs).length) {
//       addMessage({ role: "model", error: true, text: `Please fix: ${Object.values(errs).join(" ")}` });
//       return;
//     }
//     setDraftBusy(id);
//     try {
//       const ok = await page.save();
//       if (ok === false) throw new Error("Save failed. Please check the page for details.");
//       patchDraft(id, (d) => ({ ...d, saved: true }));
//     } catch (err) {
//       addMessage({ role: "model", error: true, text: err.message });
//     } finally {
//       setDraftBusy(null);
//     }
//   };

//   const startNewChat = () => {
//     setAwaitingApi(false);
//     setDrafts({});
//     setConversationId(null);
//     setMessages([]);
//     setCallSuggested(false);
//     setTooLong(false);
//     setRated(false);
//     setInput("");
//     setView("chat");
//   };

//   /* ---------- send message ---------- */
//   const sendMessage = async (e) => {
//     e?.preventDefault();
//     const text = input.trim();
//     if (!text || sending || cooldown || tooLong) return;

//     addMessage({ role: "user", text });
//     setInput("");
//     setSending(true);
//     try {
//       if (page) {
//         const spec = parseApiInput(text);
//         if ((spec && isExplicitApiPaste(text)) || awaitingApi) {
//           setAwaitingApi(false);
//           await handleIntegrationInput(text, spec);
//           return; // finally{} still clears `sending`
//         }
//       }
//       if (text.length > maxLen) {
//         addMessage({ role: "model", error: true, text: "That message is too long." });
//         return;
//       }
//       const data = await apiFetch("/chat", {
//         method: "POST",
//         body: JSON.stringify({ conversationId, message: text, pageContext: pageSnapshot() }),
//       });
//       applyReply(data);
//     } catch (err) {
//       handleError(err);
//     } finally {
//       setSending(false);
//     }
//   };

//   /* ---------- FAQ click ---------- */
//   const askFaq = async (faq) => {
//     if (sending || cooldown || tooLong) return;
//     addMessage({ role: "user", text: faq.question });
//     setSending(true);
//     try {
//       const qs = conversationId
//         ? `?conversationId=${encodeURIComponent(conversationId)}`
//         : "";
//       const data = await apiFetch(`/faq/${faq.id}${qs}`, { method: "POST" });
//       setConversationId(data.conversationId);
//       addMessage({ role: "model", text: data.reply, source: "faq" });
//       if (data.callSuggested) setCallSuggested(true);
//     } catch (err) {
//       handleError(err);
//     } finally {
//       setSending(false);
//     }
//   };

//   /* ---------- history ---------- */
//   const openHistory = async () => {
//     setView("history");
//     setHistoryLoading(true);
//     try {
//       setHistory((await apiFetch("/conversations")) || []);
//     } catch (err) {
//       setHistory([]);
//     } finally {
//       setHistoryLoading(false);
//     }
//   };

//   const openConversation = async (id) => {
//     setHistoryLoading(true);
//     try {
//       const data = await apiFetch(`/conversations/${id}`);
//       setConversationId(data.id);
//       setMessages(
//         (data.messages || []).map((m) => ({
//           role: m.role,
//           text: m.text,
//           source: m.source,
//         }))
//       );
//       setCallSuggested(!!data.callSuggested);
//       setRated(data.rating != null);
//       setTooLong(false);
//       setView("chat");
//     } catch (err) {
//       alert(err.message);
//     } finally {
//       setHistoryLoading(false);
//     }
//   };

//   /* ---------- rating ---------- */
//   const submitRating = useCallback(
//     async (rating, comment) => {
//       if (!conversationId) return;
//       setRatingBusy(true);
//       try {
//         await apiFetch(`/conversations/${conversationId}/rating`, {
//           method: "POST",
//           body: JSON.stringify(comment ? { rating, comment } : { rating }),
//         });
//         setRated(true);
//       } catch (err) {
//         addMessage({ role: "model", text: err.message, error: true });
//       } finally {
//         setRatingBusy(false);
//       }
//     },
//     [conversationId]
//   );

//   /* ---------- hide widget if logged out / inactive ---------- */
//   if (!widgetLoaded || !widget || widget.active === false) return null;

//   const faqs = widget.faqs || [];
//   const inputDisabled = sending || cooldown || tooLong;

//   return (
//     <>
//       {/* Floating Button - Right Bottom */}
//       <button
//         onClick={() => setIsOpen(true)}
//         aria-label="Open support chat"
//         className="fixed bottom-6 right-6 bg-[#673AB7] text-white p-4 rounded-full shadow-xl hover:bg-[#5E35A6] hover:scale-105 transition-all duration-300 z-50 flex items-center justify-center"
//       >
//         <MessageCircle size={28} />
//       </button>

//       {/* Background Overlay */}
//       <AnimatePresence>
//         {isOpen && (
//           <motion.div
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 0.4 }}
//             exit={{ opacity: 0 }}
//             onClick={() => setIsOpen(false)}
//             className="fixed inset-0 bg-black z-[55]"
//           />
//         )}
//       </AnimatePresence>

//       {/* Sliding Chat Panel */}
//       <AnimatePresence>
//         {isOpen && (
//           <motion.div
//             initial={{ x: "100%" }}
//             animate={{ x: 0 }}
//             exit={{ x: "100%" }}
//             transition={{ type: "spring", damping: 25, stiffness: 200 }}
//             className="fixed top-0 right-0 w-80 sm:w-96 h-full bg-[#FAF8FF] dark:bg-gray-900 shadow-2xl z-[60] flex flex-col cfg-font"
//           >
//             <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-font{font-family:'Inter',sans-serif;}`}</style>
//             {/* Header */}
//             <div className="flex justify-between items-center p-4 bg-[#673AB7] text-white shadow-md">
//               <div className="flex items-center gap-2 min-w-0">
//                 {view === "history" ? (
//                   <button
//                     onClick={() => setView("chat")}
//                     aria-label="Back to chat"
//                     className="hover:text-[#E9D5FF] transition-colors"
//                   >
//                     <ArrowLeft size={20} />
//                   </button>
//                 ) : (
//                   <MessageCircle size={20} className="text-[#C4B5FD]" />
//                 )}
//                 <h3 className="text-sm font-semibold truncate" style={{ fontFamily: "'Sora', sans-serif" }}>
//                   {view === "history" ? "Past chats" : "Support Chat"}
//                 </h3>
//               </div>

//               <div className="flex items-center gap-3">
//                 {phone && (
//                   <a
//                     href={telHref(phone)}
//                     title={hours ? `Call support (${hours})` : "Call support"}
//                     className="flex items-center gap-1 text-xs bg-white text-[#673AB7] font-semibold px-2 py-1 rounded-md hover:opacity-90 transition-opacity"
//                   >
//                     <Phone size={14} /> Call
//                   </a>
//                 )}
//                 {view === "chat" && (
//                   <button
//                     onClick={openHistory}
//                     title="Chat history"
//                     aria-label="Chat history"
//                     className="hover:text-[#E9D5FF] transition-colors"
//                   >
//                     <History size={20} />
//                   </button>
//                 )}
//                 <button
//                   onClick={startNewChat}
//                   title="New chat"
//                   aria-label="New chat"
//                   className="hover:text-[#E9D5FF] transition-colors"
//                 >
//                   <Plus size={22} />
//                 </button>
//                 <button
//                   onClick={() => setIsOpen(false)}
//                   aria-label="Close"
//                   className="hover:text-[#E9D5FF] transition-colors"
//                 >
//                   <X size={24} />
//                 </button>
//               </div>
//             </div>

//             {/* ============ HISTORY VIEW ============ */}
//             {view === "history" && (
//               <div className="flex-1 overflow-y-auto bg-white dark:bg-gray-800 p-3 space-y-2">
//                 {historyLoading ? (
//                   <div className="flex justify-center py-10">
//                     <Loader2 className="animate-spin text-[#673AB7]" />
//                   </div>
//                 ) : history.length === 0 ? (
//                   <p className="text-center text-xs text-gray-500 py-10">
//                     No past chats yet.
//                   </p>
//                 ) : (
//                   history.map((c) => (
//                     <button
//                       key={c.id}
//                       onClick={() => openConversation(c.id)}
//                       className="w-full text-left p-3 rounded-lg border border-gray-200 dark:border-gray-600 hover:bg-[#F3E8FF] dark:hover:bg-gray-700 transition-colors"
//                     >
//                       <p className="text-xs font-medium text-gray-800 dark:text-gray-100 truncate">
//                         {c.title}
//                       </p>
//                       <p className="text-xs text-gray-500 mt-1">
//                         {new Date(c.lastActivityAt).toLocaleString()} ·{" "}
//                         {c.messageCount} messages
//                         {c.rating ? ` · ${c.rating}★` : ""}
//                       </p>
//                     </button>
//                   ))
//                 )}
//               </div>
//             )}

//             {/* ============ CHAT VIEW ============ */}
//             {view === "chat" && (
//               <>
//                 <div className="flex-1 p-4 overflow-y-auto bg-gray-50 dark:bg-gray-800 space-y-3">
//                   {/* Welcome */}
//                   <div className="bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100 border border-gray-100 dark:border-gray-600 p-3 rounded-lg rounded-tl-none w-[85%] text-xs leading-relaxed shadow-sm whitespace-pre-wrap">
//                     {widget.welcomeMessage || "Hello! How can I assist you today?"}
//                   </div>

//                   {/* FAQ chips (only before the chat starts) */}
//                   {messages.length === 0 && faqs.length > 0 && (
//                     <div className="flex flex-wrap gap-2">
//                       {faqs.map((f) => (
//                         <button
//                           key={f.id}
//                           onClick={() => askFaq(f)}
//                           disabled={inputDisabled}
//                           className="text-xs px-3 py-1.5 rounded-full border border-[#673AB7] text-[#673AB7] dark:text-[#8B5CF6] dark:border-[#8B5CF6] hover:bg-[#673AB7] hover:text-white disabled:opacity-50 transition-colors text-left"
//                         >
//                           {f.question}
//                         </button>
//                       ))}
//                     </div>
//                   )}

//                   {page && messages.length === 0 && (
//                     <button
//                       onClick={startIntegration}
//                       disabled={inputDisabled}
//                       className="text-xs px-3 py-1.5 rounded-full bg-[#673AB7] text-white hover:bg-[#5E35A6] disabled:opacity-50 transition-colors"
//                     >
//                       🔌 Integrate an API on this page
//                     </button>
//                   )}

//                   {messages.map((m, i) => {
//                     if (m.kind !== "integration") return <Bubble key={i} msg={m} />;
//                     const d = drafts[m.draftId];
//                     return (
//                       <div key={i} className="space-y-2">
//                         <Bubble msg={m} />
//                         {d && page?.id === d.pageId && (
//                           <IntegrationCard
//                             draft={d}
//                             page={page}
//                             busy={draftBusy === d.id}
//                             onEdit={(k, v) => editDraft(d.id, k, v)}
//                             onApply={() => applyDraft(d.id)}
//                             onSave={() => saveDraft(d.id)}
//                             onDiscard={() => discardDraft(d.id)}
//                           />
//                         )}
//                       </div>
//                     );
//                   })}

//                   {sending && <TypingIndicator />}

//                   {callSuggested && <CallCard phone={phone} hours={hours} />}

//                   {tooLong && (
//                     <button
//                       onClick={startNewChat}
//                       className="w-full bg-[#673AB7] text-white py-1.5 rounded text-xs hover:bg-[#5E35A6] transition-colors"
//                     >
//                       Start new chat
//                     </button>
//                   )}

//                   {conversationId && userMsgCount >= 3 && !rated && !sending && (
//                     <RatingBox onSubmit={submitRating} submitting={ratingBusy} />
//                   )}
//                   {rated && (
//                     <p className="text-xs text-center text-gray-500">
//                       Thanks for your feedback!
//                     </p>
//                   )}

//                   <div ref={bottomRef} />
//                 </div>

//                 {/* Input Area */}
//                 <form
//                   onSubmit={sendMessage}
//                   className="p-4 bg-white dark:bg-gray-900 border-t dark:border-gray-700"
//                 >
//                   <div className="flex gap-2">
//                     <textarea
//                       rows={input.includes("\n") ? 4 : 1}
//                       value={input}
//                       maxLength={page ? 8000 : maxLen}
//                       onChange={(e) => setInput(e.target.value)}
//                       onKeyDown={(e) => {
//                         if (e.key === "Enter" && !e.shiftKey) {
//                           e.preventDefault();
//                           sendMessage();
//                         }
//                       }}
//                       disabled={tooLong}
//                       placeholder={
//                         tooLong ? "Start a new chat to continue" : "Type a message..."
//                       }
//                       className="flex-1 px-2.5 py-1.5 text-xs border rounded resize-none dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#8B5CF6] disabled:bg-gray-100"
//                     />
//                     <button
//                       type="submit"
//                       disabled={inputDisabled || !input.trim()}
//                       aria-label="Send"
//                       className="bg-[#673AB7] text-white px-3 py-1.5 rounded hover:bg-[#5E35A6] disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
//                     >
//                       {sending ? (
//                         <Loader2 size={20} className="animate-spin" />
//                       ) : (
//                         <Send size={20} />
//                       )}
//                     </button>
//                   </div>
//                   <p className="text-[11px] text-gray-400 text-right mt-1">
//                     {input.length}/{maxLen}
//                   </p>
//                 </form>
//               </>
//             )}
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </>
//   );
// };

// export default Chatbot;





import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  MessageCircle,
  X,
  Send,
  Phone,
  Plus,
  History,
  ArrowLeft,
  Star,
  Loader2,
  ChevronRight,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { API_URL } from "../../Constants"; // path adjust karo
import { usePageContext } from "./integration/PageContext";
import { parseApiInput, isExplicitApiPaste } from "./integration/apiSpecParser";
import { buildDraft, buildPageSnapshot, maskSecrets, sanitizeValues, validateValues } from "./integration/mapper";
import IntegrationCard from "./integration/IntegrationCard";

/* ------------------------------------------------------------------ */
/*  CONFIG – apne project ke hisaab se sirf yeh 2 cheezein badlo        */
/* ------------------------------------------------------------------ */
const API_BASE = API_URL;
// Login ke baad jis key me JWT save karte ho
const getToken = () =>
  localStorage.getItem("token") || sessionStorage.getItem("token");

/* ------------------------------------------------------------------ */
/*  API helper                                                          */
/* ------------------------------------------------------------------ */
const apiFetch = async (path, options = {}) => {
  const res = await fetch(`${API_BASE}/api/support${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${getToken()}`,
      ...(options.headers || {}),
    },
  });

  let data = null;
  const text = await res.text();
  if (text) {
    try {
      data = JSON.parse(text);
    } catch {
      data = { message: text };
    }
  }

  if (!res.ok) {
    const err = new Error(
      data?.message ||
        (res.status === 404
          ? "Conversation not found."
          : "Something went wrong. Please try again.")
    );
    err.status = res.status;
    throw err;
  }
  return data;
};

const telHref = (phone) => `tel:${(phone || "").replace(/[^\d+]/g, "")}`;

/* ------------------------------------------------------------------ */
/*  Small UI pieces                                                     */
/* ------------------------------------------------------------------ */
const TypingIndicator = () => (
  <div className="flex gap-1 bg-white dark:bg-gray-700 border border-gray-100 dark:border-gray-600 w-fit px-3 py-3 rounded-lg rounded-tl-none shadow-sm">
    {[0, 1, 2].map((i) => (
      <span
        key={i}
        className="w-2 h-2 rounded-full bg-[#673AB7]/60 dark:bg-gray-300 animate-bounce"
        style={{ animationDelay: `${i * 0.15}s` }}
      />
    ))}
  </div>
);

const Bubble = ({ msg }) => {
  const isUser = msg.role === "user";
  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div
        className={`max-w-[85%] p-3 text-xs leading-relaxed shadow-sm rounded-lg ${
          isUser
            ? "bg-[#673AB7] text-white rounded-tr-none"
            : msg.error
            ? "bg-red-50 text-red-700 border border-red-200 rounded-tl-none"
            : "bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100 border border-gray-100 dark:border-gray-600 rounded-tl-none"
        }`}
        // Plain text only – never inject as HTML
        style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {msg.text}
      </div>
    </div>
  );
};

const CallCard = ({ phone, hours }) => {
  if (!phone) return null;
  return (
    <div className="border border-[#E9D5FF] bg-[#F3E8FF] dark:bg-purple-900/30 dark:border-purple-800 rounded-lg p-3 text-xs">
      <p className="font-semibold text-[#673AB7] dark:text-white mb-1">
        Need a person? Call our support team
      </p>
      {hours && (
        <p className="text-xs text-gray-600 dark:text-gray-300 mb-2">{hours}</p>
      )}
      <a
        href={telHref(phone)}
        className="inline-flex items-center gap-2 bg-[#673AB7] hover:bg-[#5E35A6] text-white px-3 py-1.5 rounded-md font-medium transition-colors"
      >
        <Phone size={16} /> Call {phone}
      </a>
    </div>
  );
};

const RatingBox = ({ onSubmit, submitting }) => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");

  return (
    <div className="border border-gray-100 dark:border-gray-600 rounded-lg p-3 text-xs bg-white dark:bg-gray-700">
      <p className="font-medium text-gray-800 dark:text-gray-100 mb-2">
        How was this chat?
      </p>
      <div className="flex gap-1 mb-2">
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            type="button"
            onMouseEnter={() => setHover(n)}
            onMouseLeave={() => setHover(0)}
            onClick={() => setRating(n)}
            aria-label={`${n} star`}
          >
            <Star
              size={24}
              className={
                n <= (hover || rating)
                  ? "fill-[#8B5CF6] text-[#673AB7]"
                  : "text-gray-300"
              }
            />
          </button>
        ))}
      </div>
      {rating > 0 && (
        <>
          <textarea
            value={comment}
            maxLength={500}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Anything to add? (optional)"
            rows={2}
            className="w-full px-2.5 py-1.5 border rounded text-xs dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#8B5CF6]"
          />
          <button
            onClick={() => onSubmit(rating, comment.trim())}
            disabled={submitting}
            className="mt-2 bg-[#673AB7] text-white px-3 py-1.5 rounded hover:bg-[#5E35A6] disabled:opacity-60 transition-colors"
          >
            {submitting ? "Sending..." : "Submit rating"}
          </button>
        </>
      )}
    </div>
  );
};

/* ------------------------------------------------------------------ */
/*  Main component                                                      */
/* ------------------------------------------------------------------ */
const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState("chat"); // "chat" | "history"

  // widget settings
  const [widget, setWidget] = useState(null);
  const [widgetLoaded, setWidgetLoaded] = useState(false);

  // chat state
  const [conversationId, setConversationId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [sending, setSending] = useState(false);
  const [callSuggested, setCallSuggested] = useState(false);
  const [contact, setContact] = useState({ phone: null, hours: null });
  const [tooLong, setTooLong] = useState(false);
  const [rated, setRated] = useState(false);
  const [ratingBusy, setRatingBusy] = useState(false);

  // history
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);

  const bottomRef = useRef(null);
  const cooldownRef = useRef(null);
  const [cooldown, setCooldown] = useState(false);

  // page-aware API integration
  const { page, pathname } = usePageContext();
  const [drafts, setDrafts] = useState({});
  const [draftBusy, setDraftBusy] = useState(null);
  const [awaitingApi, setAwaitingApi] = useState(false);

  const maxLen = widget?.maxMessageLength || 1000;
  const phone = contact.phone || widget?.supportPhoneNumber || null;
  const hours = contact.hours || widget?.supportHours || null;
  const userMsgCount = messages.filter((m) => m.role === "user").length;

  /* ---------- load widget settings once (user must be logged in) ---------- */
  useEffect(() => {
    if (!getToken()) {
      setWidgetLoaded(true);
      return;
    }
    let alive = true;
    apiFetch("/widget")
      .then((data) => {
        if (!alive) return;
        setWidget(data);
        setContact({
          phone: data.supportPhoneNumber,
          hours: data.supportHours,
        });
      })
      .catch(() => {
        if (alive) setWidget(null);
      })
      .finally(() => alive && setWidgetLoaded(true));
    return () => {
      alive = false;
      clearTimeout(cooldownRef.current);
    };
  }, []);

  /* ---------- auto scroll ---------- */
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, sending, callSuggested, view, isOpen]);

  /* ---------- helpers ---------- */
  const addMessage = (msg) => setMessages((prev) => [...prev, msg]);

  const startCooldown = (ms = 4000) => {
    setCooldown(true);
    clearTimeout(cooldownRef.current);
    cooldownRef.current = setTimeout(() => setCooldown(false), ms);
  };

  const applyReply = (data) => {
    setConversationId(data.conversationId);
    addMessage({
      role: "model",
      text: data.reply,
      source: data.callSuggested ? "system" : "ai",
    });
    if (data.callSuggested) setCallSuggested(true);
    if (data.supportPhoneNumber || data.supportHours) {
      setContact({
        phone: data.supportPhoneNumber,
        hours: data.supportHours,
      });
    }
  };

  const handleError = (err) => {
    if (err.status === 409 && /long/i.test(err.message)) {
      setTooLong(true);
    }
    if (err.status === 429) startCooldown();
    addMessage({ role: "model", text: err.message, error: true });
  };

  /* ---------- page-aware API integration ---------- */
  const pageSnapshot = () => (page ? buildPageSnapshot(page, pathname) : null);
  const patchDraft = (id, fn) => setDrafts((d) => (d[id] ? { ...d, [id]: fn(d[id]) } : d));

  const startIntegration = () => {
    setAwaitingApi(true);
    addMessage({
      role: "model",
      text: `Paste your provider's cURL command, a "POST https://…" request with headers/body, or its docs. I'll map it to the ${page.title} fields so you can review it before saving.`,
    });
  };

  const handleIntegrationInput = async (text, spec) => {
    let draft = spec ? buildDraft(page, spec) : null;
    if (!draft) {
      // Optional AI fallback for messy docs. Secrets are masked before leaving the browser.
      const { masked, restore } = maskSecrets(text);
      try {
        const data = await apiFetch("/integration/map", {
          method: "POST",
          body: JSON.stringify({ pageContext: pageSnapshot(), input: masked }),
        });
        const values = sanitizeValues(page.fields, restore(data?.values || {}));
        if (Object.keys(values).length)
          draft = {
            id: `d_${Date.now()}`,
            pageId: page.id,
            spec: { method: values.httpMethod || "", baseUrl: values.url || "" },
            values,
            applied: false,
            saved: false,
          };
      } catch {
        /* fall through */
      }
    }
    if (!draft) {
      addMessage({
        role: "model",
        error: true,
        text: "I couldn't read an API request from that. Please paste a cURL command or a request like “POST https://…” with its headers and body.",
      });
      return;
    }
    setDrafts((d) => ({ ...d, [draft.id]: draft }));
    addMessage({
      role: "model",
      kind: "integration",
      draftId: draft.id,
      text: "I've mapped your API to this page. Review the values, then fill the form.",
    });
  };

  const editDraft = (id, key, value) =>
    patchDraft(id, (d) => ({ ...d, values: { ...d.values, [key]: value }, applied: false }));
  const applyDraft = (id) => {
    page.setValues(drafts[id].values);
    patchDraft(id, (d) => ({ ...d, applied: true }));
  };
  const discardDraft = (id) =>
    setDrafts((d) => {
      const n = { ...d };
      delete n[id];
      return n;
    });

  const saveDraft = async (id) => {
    // validate what is actually on the page, not just the draft
    const errs = validateValues(page.fields, page.getValues(), page.validate);
    if (Object.keys(errs).length) {
      addMessage({ role: "model", error: true, text: `Please fix: ${Object.values(errs).join(" ")}` });
      return;
    }
    setDraftBusy(id);
    try {
      const ok = await page.save();
      if (ok === false) throw new Error("Save failed. Please check the page for details.");
      patchDraft(id, (d) => ({ ...d, saved: true }));
    } catch (err) {
      addMessage({ role: "model", error: true, text: err.message });
    } finally {
      setDraftBusy(null);
    }
  };

  const startNewChat = () => {
    setAwaitingApi(false);
    setDrafts({});
    setConversationId(null);
    setMessages([]);
    setCallSuggested(false);
    setTooLong(false);
    setRated(false);
    setInput("");
    setView("chat");
  };

  /* ---------- send message ---------- */
  const sendMessage = async (e) => {
    e?.preventDefault();
    const text = input.trim();
    if (!text || sending || cooldown || tooLong) return;

    addMessage({ role: "user", text });
    setInput("");
    setSending(true);
    try {
      if (page) {
        const spec = parseApiInput(text);
        if ((spec && isExplicitApiPaste(text)) || awaitingApi) {
          setAwaitingApi(false);
          await handleIntegrationInput(text, spec);
          return; // finally{} still clears `sending`
        }
      }
      if (text.length > maxLen) {
        addMessage({ role: "model", error: true, text: "That message is too long." });
        return;
      }
      const data = await apiFetch("/chat", {
        method: "POST",
        body: JSON.stringify({ conversationId, message: text, pageContext: pageSnapshot() }),
      });
      applyReply(data);
    } catch (err) {
      handleError(err);
    } finally {
      setSending(false);
    }
  };

  /* ---------- FAQ click ---------- */
  const askFaq = async (faq) => {
    if (sending || cooldown || tooLong) return;
    addMessage({ role: "user", text: faq.question });
    setSending(true);
    try {
      const qs = conversationId
        ? `?conversationId=${encodeURIComponent(conversationId)}`
        : "";
      const data = await apiFetch(`/faq/${faq.id}${qs}`, { method: "POST" });
      setConversationId(data.conversationId);
      addMessage({ role: "model", text: data.reply, source: "faq" });
      if (data.callSuggested) setCallSuggested(true);
    } catch (err) {
      handleError(err);
    } finally {
      setSending(false);
    }
  };

  /* ---------- history ---------- */
  const openHistory = async () => {
    setView("history");
    setHistoryLoading(true);
    try {
      setHistory((await apiFetch("/conversations")) || []);
    } catch (err) {
      setHistory([]);
    } finally {
      setHistoryLoading(false);
    }
  };

  const openConversation = async (id) => {
    setHistoryLoading(true);
    try {
      const data = await apiFetch(`/conversations/${id}`);
      setConversationId(data.id);
      setMessages(
        (data.messages || []).map((m) => ({
          role: m.role,
          text: m.text,
          source: m.source,
        }))
      );
      setCallSuggested(!!data.callSuggested);
      setRated(data.rating != null);
      setTooLong(false);
      setView("chat");
    } catch (err) {
      alert(err.message);
    } finally {
      setHistoryLoading(false);
    }
  };

  /* ---------- rating ---------- */
  const submitRating = useCallback(
    async (rating, comment) => {
      if (!conversationId) return;
      setRatingBusy(true);
      try {
        await apiFetch(`/conversations/${conversationId}/rating`, {
          method: "POST",
          body: JSON.stringify(comment ? { rating, comment } : { rating }),
        });
        setRated(true);
      } catch (err) {
        addMessage({ role: "model", text: err.message, error: true });
      } finally {
        setRatingBusy(false);
      }
    },
    [conversationId]
  );

  /* ---------- hide widget if logged out / inactive ---------- */
  if (!widgetLoaded || !widget || widget.active === false) return null;

  const faqs = widget.faqs || [];
  const inputDisabled = sending || cooldown || tooLong;

  return (
    <>
      {/* Background Overlay */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.4 }}
            exit={{ opacity: 0 }}
            onClick={() => setIsOpen(false)}
            className="fixed inset-0 bg-black z-[55]"
          />
        )}
      </AnimatePresence>

      {/* Sliding Chat Panel (always mounted) + attached edge tab */}
      <motion.aside
        initial={false}
        animate={
          isOpen
            ? { x: 0, visibility: "visible" }
            : { x: "100%", transitionEnd: { visibility: "hidden" } }
        }
        transition={{ type: "spring", damping: 25, stiffness: 200 }}
        aria-hidden={!isOpen}
        className="fixed top-0 right-0 w-[min(20rem,calc(100vw-3rem))] sm:w-96 h-full bg-[#FAF8FF] dark:bg-gray-900 shadow-2xl z-[60] flex flex-col cfg-font"
      >
        {/* Edge tab styles: fixed size (no hover resize) */}
        <style>{`
          .sup-tab{width:36px;min-height:112px;-webkit-tap-highlight-color:transparent;touch-action:manipulation}
          @media (max-width:380px){
            .sup-tab{min-height:96px}
          }
        `}</style>

        {/* Edge tab: panel ke left edge se chipka hai, panel ke saath move hota hai */}
        <button
          type="button"
          onClick={() => setIsOpen((o) => !o)}
          aria-label={isOpen ? "Close support chat" : "Open support chat"}
          aria-expanded={isOpen}
          data-open={isOpen}
          style={{ visibility: "visible" }}
          className="sup-tab group absolute right-full top-1/2 -translate-y-1/2 flex flex-col items-start gap-2 py-3 overflow-hidden rounded-l-lg bg-[#673AB7] hover:bg-[#5E35A6] text-white shadow-[-3px_0_12px_rgba(103,58,183,0.30)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#C4B5FD]"
        >
          {/* Icon: hamesha poora dikhta hai */}
          <span className="flex justify-center w-9 shrink-0">
            {isOpen ? <ChevronRight size={18} /> : <MessageCircle size={18} />}
          </span>
          {/* Text: neeche se upar padhta hai */}
          <span className="flex justify-center w-9 shrink-0">
            <span
              className="text-[10px] font-semibold tracking-widest uppercase whitespace-nowrap"
              style={{
                writingMode: "vertical-rl",
                transform: "rotate(180deg)",
                fontFamily: "'Sora', sans-serif",
              }}
            >
              Support
            </span>
          </span>
        </button>

            <style>{`@import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap'); .cfg-font{font-family:'Inter',sans-serif;}`}</style>
            {/* Header */}
            <div className="flex justify-between items-center p-4 bg-[#673AB7] text-white shadow-md">
              <div className="flex items-center gap-2 min-w-0">
                {view === "history" ? (
                  <button
                    onClick={() => setView("chat")}
                    aria-label="Back to chat"
                    className="hover:text-[#E9D5FF] transition-colors"
                  >
                    <ArrowLeft size={20} />
                  </button>
                ) : (
                  <MessageCircle size={20} className="text-[#C4B5FD]" />
                )}
                <h3 className="text-sm font-semibold truncate" style={{ fontFamily: "'Sora', sans-serif" }}>
                  {view === "history" ? "Past chats" : "Support Chat"}
                </h3>
              </div>

              <div className="flex items-center gap-3">
                {phone && (
                  <a
                    href={telHref(phone)}
                    title={hours ? `Call support (${hours})` : "Call support"}
                    className="flex items-center gap-1 text-xs bg-white text-[#673AB7] font-semibold px-2 py-1 rounded-md hover:opacity-90 transition-opacity"
                  >
                    <Phone size={14} /> Call
                  </a>
                )}
                {view === "chat" && (
                  <button
                    onClick={openHistory}
                    title="Chat history"
                    aria-label="Chat history"
                    className="hover:text-[#E9D5FF] transition-colors"
                  >
                    <History size={20} />
                  </button>
                )}
                <button
                  onClick={startNewChat}
                  title="New chat"
                  aria-label="New chat"
                  className="hover:text-[#E9D5FF] transition-colors"
                >
                  <Plus size={22} />
                </button>
                <button
                  onClick={() => setIsOpen(false)}
                  aria-label="Close"
                  className="hover:text-[#E9D5FF] transition-colors"
                >
                  <X size={24} />
                </button>
              </div>
            </div>

            {/* ============ HISTORY VIEW ============ */}
            {view === "history" && (
              <div className="flex-1 overflow-y-auto bg-white dark:bg-gray-800 p-3 space-y-2">
                {historyLoading ? (
                  <div className="flex justify-center py-10">
                    <Loader2 className="animate-spin text-[#673AB7]" />
                  </div>
                ) : history.length === 0 ? (
                  <p className="text-center text-xs text-gray-500 py-10">
                    No past chats yet.
                  </p>
                ) : (
                  history.map((c) => (
                    <button
                      key={c.id}
                      onClick={() => openConversation(c.id)}
                      className="w-full text-left p-3 rounded-lg border border-gray-200 dark:border-gray-600 hover:bg-[#F3E8FF] dark:hover:bg-gray-700 transition-colors"
                    >
                      <p className="text-xs font-medium text-gray-800 dark:text-gray-100 truncate">
                        {c.title}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {new Date(c.lastActivityAt).toLocaleString()} ·{" "}
                        {c.messageCount} messages
                        {c.rating ? ` · ${c.rating}★` : ""}
                      </p>
                    </button>
                  ))
                )}
              </div>
            )}

            {/* ============ CHAT VIEW ============ */}
            {view === "chat" && (
              <>
                <div className="flex-1 p-4 overflow-y-auto bg-gray-50 dark:bg-gray-800 space-y-3">
                  {/* Welcome */}
                  <div className="bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100 border border-gray-100 dark:border-gray-600 p-3 rounded-lg rounded-tl-none w-[85%] text-xs leading-relaxed shadow-sm whitespace-pre-wrap">
                    {widget.welcomeMessage || "Hello! How can I assist you today?"}
                  </div>

                  {/* FAQ chips (only before the chat starts) */}
                  {messages.length === 0 && faqs.length > 0 && (
                    <div className="flex flex-wrap gap-2">
                      {faqs.map((f) => (
                        <button
                          key={f.id}
                          onClick={() => askFaq(f)}
                          disabled={inputDisabled}
                          className="text-xs px-3 py-1.5 rounded-full border border-[#673AB7] text-[#673AB7] dark:text-[#8B5CF6] dark:border-[#8B5CF6] hover:bg-[#673AB7] hover:text-white disabled:opacity-50 transition-colors text-left"
                        >
                          {f.question}
                        </button>
                      ))}
                    </div>
                  )}

                  {page && messages.length === 0 && (
                    <button
                      onClick={startIntegration}
                      disabled={inputDisabled}
                      className="text-xs px-3 py-1.5 rounded-full bg-[#673AB7] text-white hover:bg-[#5E35A6] disabled:opacity-50 transition-colors"
                    >
                      🔌 Integrate an API on this page
                    </button>
                  )}

                  {messages.map((m, i) => {
                    if (m.kind !== "integration") return <Bubble key={i} msg={m} />;
                    const d = drafts[m.draftId];
                    return (
                      <div key={i} className="space-y-2">
                        <Bubble msg={m} />
                        {d && page?.id === d.pageId && (
                          <IntegrationCard
                            draft={d}
                            page={page}
                            busy={draftBusy === d.id}
                            onEdit={(k, v) => editDraft(d.id, k, v)}
                            onApply={() => applyDraft(d.id)}
                            onSave={() => saveDraft(d.id)}
                            onDiscard={() => discardDraft(d.id)}
                          />
                        )}
                      </div>
                    );
                  })}

                  {sending && <TypingIndicator />}

                  {callSuggested && <CallCard phone={phone} hours={hours} />}

                  {tooLong && (
                    <button
                      onClick={startNewChat}
                      className="w-full bg-[#673AB7] text-white py-1.5 rounded text-xs hover:bg-[#5E35A6] transition-colors"
                    >
                      Start new chat
                    </button>
                  )}

                  {conversationId && userMsgCount >= 3 && !rated && !sending && (
                    <RatingBox onSubmit={submitRating} submitting={ratingBusy} />
                  )}
                  {rated && (
                    <p className="text-xs text-center text-gray-500">
                      Thanks for your feedback!
                    </p>
                  )}

                  <div ref={bottomRef} />
                </div>

                {/* Input Area */}
                <form
                  onSubmit={sendMessage}
                  className="p-4 bg-white dark:bg-gray-900 border-t dark:border-gray-700"
                >
                  <div className="flex gap-2">
                    <textarea
                      rows={input.includes("\n") ? 4 : 1}
                      value={input}
                      maxLength={page ? 8000 : maxLen}
                      onChange={(e) => setInput(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" && !e.shiftKey) {
                          e.preventDefault();
                          sendMessage();
                        }
                      }}
                      disabled={tooLong}
                      placeholder={
                        tooLong ? "Start a new chat to continue" : "Type a message..."
                      }
                      className="flex-1 px-2.5 py-1.5 text-xs border rounded resize-none dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#8B5CF6] disabled:bg-gray-100"
                    />
                    <button
                      type="submit"
                      disabled={inputDisabled || !input.trim()}
                      aria-label="Send"
                      className="bg-[#673AB7] text-white px-3 py-1.5 rounded hover:bg-[#5E35A6] disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center"
                    >
                      {sending ? (
                        <Loader2 size={20} className="animate-spin" />
                      ) : (
                        <Send size={20} />
                      )}
                    </button>
                  </div>
                  <p className="text-[11px] text-gray-400 text-right mt-1">
                    {input.length}/{maxLen}
                  </p>
                </form>
              </>
            )}
      </motion.aside>
    </>
  );
};

export default Chatbot;